import {hasAnalyticsConsent, isGpcActive, parseConsentCookie} from "@/lib/consentCookie";

const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY || "";
const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com";
const POSTHOG_DISABLED =
    process.env.NODE_ENV === "development" ||
    process.env.NEXT_PUBLIC_DISABLE_POSTHOG === "true";

let started = false;

function applyConsent(posthog: typeof import("posthog-js").default) {
    if (isGpcActive() || !parseConsentCookie()?.analytics) {
        posthog.opt_out_capturing();
        return;
    }
    posthog.opt_in_capturing();
}

/** Loads posthog-js on first use so it is not in the auth shell's initial JS. */
export async function initDeferredPostHog(): Promise<void> {
    if (typeof window === "undefined" || !POSTHOG_KEY || POSTHOG_DISABLED) return;
    const {default: posthog} = await import("posthog-js");
    if (!started) {
        posthog.init(POSTHOG_KEY, {
            api_host: POSTHOG_HOST,
            capture_pageview: false,
            opt_out_capturing_by_default: true,
            on_request_error: () => {
                // Analytics should never interrupt the app when PostHog is blocked or unreachable.
            },
        });
        started = true;
        document.addEventListener("braiv:consent", () => applyConsent(posthog));
    }
    applyConsent(posthog);
}

export async function captureDeferredPageview(): Promise<void> {
    await initDeferredPostHog();
    if (!POSTHOG_KEY || POSTHOG_DISABLED || !hasAnalyticsConsent()) return;
    const {default: posthog} = await import("posthog-js");
    if (!posthog.has_opted_out_capturing()) {
        posthog.capture("$pageview");
    }
}
